import defaultTheme from "./defaultTheme";
export var typographyKeys = Object.keys(defaultTheme.typography);
export var colorKeys = Object.keys(defaultTheme.colors);
export var accentColorKeys = colorKeys.filter(function (color) {
  return !color.includes("background") && !color.includes("custom") && !color.includes("overlay");
});
export var backgroundColorKeys = colorKeys.filter(function (color) {
  return color.includes("background");
});
export var customColorKeys = colorKeys.filter(function (color) {
  return color.includes("custom");
});
export var emphasisKeys = Object.keys(defaultTheme.colors.primary.onColor.emphasis);
export var boxShadowKeys = Object.keys(defaultTheme.boxShadow);
export var borderRadiusKeys = Object.keys(defaultTheme.borderRadius);